// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/LoginBackground.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_background__x7Da0 {
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  display: flex;
  height: 100vh !important;
  padding-left: 120px;
}
.Login_container__MRjgM {
  align-items: center;
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 64px 48px 24px;
}
.Login_logo__iSbee {
  height: 100px;
  margin-bottom: 72px;
  width: 348px;
}
.Login_heading__0Lf1r {
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  margin-bottom: 48px;
  text-align: center;
  color: #4d4d4d;
}

.Login_buttonContainer__Pvwot {
  display: flex;
  flex-direction: column;
  margin-bottom: 64px;
  row-gap: 16px;
  width: 100%;
}
.Login_googleButton__LTE04 {
  align-items: center;
  background-color: #fff;
  border: 1px solid rgba(210, 218, 238, 1);
  border-radius: 8px;
  column-gap: 16px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 16px, 24px, 16px, 24px;
  transition: background-color 300ms ease-in-out;
}
.Login_googleButton__LTE04:hover {
  background-color: #f1f5ff;
  transition: background-color 300ms ease-in-out;
}
.Login_googleIcon__5fHQK {
  height: 25px;
  width: 25px;
}
.Login_googleButtonText__bqv83 {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.Login_appleButton__Ig-\\+1 {
  align-items: center;
  background-color: #000;
  border: none;
  border-radius: 8px;
  column-gap: 16px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: background-color 300ms ease-in-out;
}
.Login_appleButton__Ig-\\+1:hover {
  background-color: #4d4d4d;
  transition: background-color 300ms ease-in-out;
}
.Login_appleIcon__OM4Cb {
  height: 25px;
  width: 25px;
}
.Login_appleButtonText__M-Aan {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.Login_bottomContainer__62LXc {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  width: 100%;
}
.Login_bottomHeadingRow__wI-JO {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
}
.Login_headingLine__9ZTR\\+ {
  border: 0.5px solid #d2daee;
  display: flex;
  width: 100%;
}
.Login_bottomHeading__aGCpY {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-align: center;
  width: -webkit-fill-available;
}
.Login_bottomContent__VeK3H {
  display: flex;
  flex-direction: column;
  width: 472px;
}
.Login_bottomText__MjZth {
  color: #777777;
  cursor: default;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  font-family: Inter;
  margin: 8px 0px 0px;
}
.Login_link__mVtCj {
  color: #cb9c2d;
  text-decoration: none;
}

@media screen and (max-width: 765px) {
  .Login_container__MRjgM {
    width: 85%;
    box-sizing: border-box;
    padding: 50px 15px 20px;
  }
  .Login_background__x7Da0 {
    justify-content: center;
    padding-left: 0;
  }
  .Login_bottomContainer__62LXc {
    justify-content: center;
    align-items: center;
  }
  .Login_bottomContent__VeK3H {
    width: 100%;
  }
  .Login_logo__iSbee {
    width: 95%;
  }
  .Login_buttonContainer__Pvwot {
    width: 90%;
  }
}

@media screen and (max-width: 450px) {
  .Login_buttonContainer__Pvwot {
    width: 95%;
  }
  .Login_bottomHeading__aGCpY {
    font-size: 14px;
    width: 350px;
    padding: 0 20px;
  }
  .Login_bottomText__MjZth {
    font-size: 14px;
  }
  .Login_appleButtonText__M-Aan,
  .Login_googleButtonText__bqv83 {
    font-size: 14px;
  }
  .Login_appleButton__Ig-\\+1,
  .Login_googleButton__LTE04 {
    gap: 10px;
  }
}

@media screen and (max-width: 415px) {
  .Login_heading__0Lf1r {
    margin-bottom: 40px;
  }

  .Login_logo__iSbee {
    margin-bottom: 60px;
  }
  .Login_container__MRjgM {
    padding-top: 20px;
  }
  .Login_bottomHeading__aGCpY {
    font-size: 14px;
    width: 400px;
    padding: 0 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/loginPage/Login.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yDAA8D;EAC9D,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,SAAS;EACX;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".background {\n  align-items: center;\n  background-image: url(\"../../assets/img/LoginBackground.webp\");\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  height: 100vh !important;\n  padding-left: 120px;\n}\n.container {\n  align-items: center;\n  background-color: #fff;\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 64px 48px 24px;\n}\n.logo {\n  height: 100px;\n  margin-bottom: 72px;\n  width: 348px;\n}\n.heading {\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  margin-bottom: 48px;\n  text-align: center;\n  color: #4d4d4d;\n}\n\n.buttonContainer {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 64px;\n  row-gap: 16px;\n  width: 100%;\n}\n.googleButton {\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid rgba(210, 218, 238, 1);\n  border-radius: 8px;\n  column-gap: 16px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  padding: 16px, 24px, 16px, 24px;\n  transition: background-color 300ms ease-in-out;\n}\n.googleButton:hover {\n  background-color: #f1f5ff;\n  transition: background-color 300ms ease-in-out;\n}\n.googleIcon {\n  height: 25px;\n  width: 25px;\n}\n.googleButtonText {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.appleButton {\n  align-items: center;\n  background-color: #000;\n  border: none;\n  border-radius: 8px;\n  column-gap: 16px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  transition: background-color 300ms ease-in-out;\n}\n.appleButton:hover {\n  background-color: #4d4d4d;\n  transition: background-color 300ms ease-in-out;\n}\n.appleIcon {\n  height: 25px;\n  width: 25px;\n}\n.appleButtonText {\n  color: #fff;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.bottomContainer {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 8px;\n  width: 100%;\n}\n.bottomHeadingRow {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n.headingLine {\n  border: 0.5px solid #d2daee;\n  display: flex;\n  width: 100%;\n}\n.bottomHeading {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-align: center;\n  width: -webkit-fill-available;\n}\n.bottomContent {\n  display: flex;\n  flex-direction: column;\n  width: 472px;\n}\n.bottomText {\n  color: #777777;\n  cursor: default;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  font-family: Inter;\n  margin: 8px 0px 0px;\n}\n.link {\n  color: #cb9c2d;\n  text-decoration: none;\n}\n\n@media screen and (max-width: 765px) {\n  .container {\n    width: 85%;\n    box-sizing: border-box;\n    padding: 50px 15px 20px;\n  }\n  .background {\n    justify-content: center;\n    padding-left: 0;\n  }\n  .bottomContainer {\n    justify-content: center;\n    align-items: center;\n  }\n  .bottomContent {\n    width: 100%;\n  }\n  .logo {\n    width: 95%;\n  }\n  .buttonContainer {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .buttonContainer {\n    width: 95%;\n  }\n  .bottomHeading {\n    font-size: 14px;\n    width: 350px;\n    padding: 0 20px;\n  }\n  .bottomText {\n    font-size: 14px;\n  }\n  .appleButtonText,\n  .googleButtonText {\n    font-size: 14px;\n  }\n  .appleButton,\n  .googleButton {\n    gap: 10px;\n  }\n}\n\n@media screen and (max-width: 415px) {\n  .heading {\n    margin-bottom: 40px;\n  }\n\n  .logo {\n    margin-bottom: 60px;\n  }\n  .container {\n    padding-top: 20px;\n  }\n  .bottomHeading {\n    font-size: 14px;\n    width: 400px;\n    padding: 0 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `Login_background__x7Da0`,
	"container": `Login_container__MRjgM`,
	"logo": `Login_logo__iSbee`,
	"heading": `Login_heading__0Lf1r`,
	"buttonContainer": `Login_buttonContainer__Pvwot`,
	"googleButton": `Login_googleButton__LTE04`,
	"googleIcon": `Login_googleIcon__5fHQK`,
	"googleButtonText": `Login_googleButtonText__bqv83`,
	"appleButton": `Login_appleButton__Ig-+1`,
	"appleIcon": `Login_appleIcon__OM4Cb`,
	"appleButtonText": `Login_appleButtonText__M-Aan`,
	"bottomContainer": `Login_bottomContainer__62LXc`,
	"bottomHeadingRow": `Login_bottomHeadingRow__wI-JO`,
	"headingLine": `Login_headingLine__9ZTR+`,
	"bottomHeading": `Login_bottomHeading__aGCpY`,
	"bottomContent": `Login_bottomContent__VeK3H`,
	"bottomText": `Login_bottomText__MjZth`,
	"link": `Login_link__mVtCj`
};
export default ___CSS_LOADER_EXPORT___;
